import _range from 'lodash/range';
import * as React from 'react';

import { Skeleton } from '@/components/ui/skeleton';

function HiringGoalDetailsListSkeleton() {
  return (
    <div className="flex w-full flex-col gap-4 self-stretch">
      {_range(3).map(index => (
        <div key={index} className="rounded-lg bg-white p-4 shadow-sm">
          <div className="flex items-center justify-between">
            <Skeleton className="h-5 w-28" />
            <Skeleton className="h-8 w-20" />
          </div>
          <div className="mt-3">
            <Skeleton className="h-2 w-full" />
          </div>
          <div className="mt-4 flex justify-between">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-3 w-16" />
              <Skeleton className="h-4 w-40" />
            </div>
            <div className="flex flex-col items-end gap-2">
              <Skeleton className="h-3 w-16" />
              <div className="flex items-center gap-4">
                <Skeleton className="h-4 w-16" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export { HiringGoalDetailsListSkeleton };
